
export const customerTypes ={
  COMPANY : 1,
  PERSON : 2
}
